import React , { Suspense, lazy, useEffect }  from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { initGA } from './utils/analytics';

// Routes protection
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';

// Layouts
import MainLayout from './layouts/MainLayout';
import InnerPagesLayout from './layouts/InnerPagesLayout';

// Loader
import LoaderTemplate from "./components/LoaderTemplate";

function App() {
  // Initialize Google Analytics on app load
  useEffect(() => {
    initGA();
  }, []);

  const HomePage = lazy(() => import('./views/Home'));
  const RegisterPage = lazy(() => import('./modules/auth/Register'));
  const ResourceCenterPage = lazy(() => import('./modules/resourceCenter/ResourceCenter'));
  const MultiStepFormPage = lazy(() => import('./modules/resourceCenter/MultiStepForm'));
  const RCDetailsPage = lazy(() => import('./modules/resourceCenter/RCDetails'));
  const RCRequestSupportPage = lazy(() => import('./modules/resourceCenter/RCRequestSupport'));
  const RCSubmitFeedbackPage = lazy(() => import('./modules/resourceCenter/RCSupportFeedback'));
  const LazyErrorTemplate = lazy(() => import('./components/ErrorTemplate'));
  const LazyEmptyTemplate = lazy(() => import('./components/EmptyTemplate'));
  const LazyAuthCallback = lazy(() => import('./modules/auth/AuthCallback'));
  const ISDBHistoryPage = lazy(() => import('./modules/isdbHistory/ISDBHistory'));
  return (
    <AuthProvider>
      <ToastContainer position="bottom-left" autoClose={5000} pauseOnHover theme="light" />
      <ScrollToTop />
      <Suspense fallback={<div className="text-center mt-5"><LoaderTemplate /></div>}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={ <HomePage /> } />
          </Route>
          <Route element={<InnerPagesLayout />}>
            <Route path="/register" element={<PublicRoute> <RegisterPage /> </PublicRoute>} />
            <Route path="/resources/addResourceCenterRequest" element={<PrivateRoute> <MultiStepFormPage /> </PrivateRoute>} />
            <Route path="/resources" element={ <ResourceCenterPage /> } />
            <Route path="/isdbhistory" element={ <ISDBHistoryPage /> } />
            <Route path="/resources/:id" element={ <RCDetailsPage /> } />
            <Route path="/resources/:id/requestSupport" element={<PrivateRoute> <RCRequestSupportPage /> </PrivateRoute>} />
            <Route path="/resources/:id/submitFeedback" element={<PrivateRoute> <RCSubmitFeedbackPage /> </PrivateRoute>} />
            <Route path="/auth-callback" element={ <LazyAuthCallback /> } />
            <Route path="/404" element={<div className="error-template-container d-flex justify-content-center align-items-center text-center"> <LazyErrorTemplate /> </div>} />
            <Route path="*" element={<div className="error-template-container d-flex justify-content-center align-items-center text-center"> <LazyErrorTemplate /> </div>} />
            <Route path="/auth-error" element={<div className="error-template-container d-flex justify-content-center align-items-center text-center"> <LazyEmptyTemplate /> </div>} />
          </Route>
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;